import { createRoutine } from 'redux-saga-routines';

export const requestOtp = createRoutine('REQUEST_OTP');
export const verifyOtp = createRoutine('VERIFY_OTP');
export const forgotPassword = createRoutine('FORGOT_PASSWORD');
